import { Component, OnInit, OnChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OcrService } from '../core/services/ocr.service';
import { OcrDocumentUploaderComponent } from './ocr-document-uploader/ocr-document-uploader.component';
import { CommonService } from '../core/services/common.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ocr',
  templateUrl: './ocr.component.html',
  styleUrls: ['./ocr.component.css']
})
export class OcrComponent implements OnInit, OnChanges {

  dataEntryForm: FormGroup;
  docType: string = '';
  ocrData: any;
  showValidationForm = false;
  autoVerifyData: any;
  showAutoVerifyDetails = false;
  showDocType = false;
  showDocUploadInstructions = true;
  unableToValidate = false;
  lotId: number;
  employeeId: any;
  @ViewChild(OcrDocumentUploaderComponent) documentUploader: OcrDocumentUploaderComponent;


  constructor(private fb: FormBuilder, private ocrService: OcrService, private commonService: CommonService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.lotId = +(this.activatedRoute.snapshot.params.id);

    this.initForm();
    this.showValidationForm = false;
    this.showAutoVerifyDetails = false;
    this.ngOnChanges();
  }

  initForm() {
    this.dataEntryForm = this.fb.group({
      'de_type': ['', Validators.required],
      'doc_type': ['', Validators.required]
    });


  }

  ngOnChanges(): void {

    this.dataEntryForm.get('de_type').valueChanges.subscribe((type) => {
      if (type === 'bike') {
        this.dataEntryForm.get('doc_type').setValue('dl');
      } else {
        this.dataEntryForm.get('doc_type').setValue('pan');
      }
    });

    this.dataEntryForm.get('doc_type').valueChanges.subscribe((docType) => {
      this.docType = docType;
    });

  }

  documentsUploaded(links) {

    const data = {
      data: links
    };

    this.ocrService.extractDetails(data).subscribe(response => {


      this.ocrData = response.data;
      this.showValidationForm = true;
    });
  }

  validationFormSubmitted(data) {

    if (this.docType === 'dl')
      this.autoVerifyDl(data);

    if (this.docType === 'pan')
      this.autoVerifyPan(data);
  }

  autoVerifyDl(data) {

    const params = {
      ...data,
      lotId: this.lotId,
      sources: [{
        index: 'parivahan_application'
      }, {
        index: 'parivahan_sarathi'
      },
      {
        index: 'parivahan_simple'
      },
      {
        index: 'state'
        }]
    };

    this.ocrService.autoVerifyDl(params).subscribe(response => {

      this.autoVerifyData = response;

      this.employeeId = response.employee_id;

      if (response.description === "Details Found") {
        return this.showAutoVerifyDetails = true;
      }

      this.OnUnableToValidateDl();
    });
  }

  autoVerifyPan(data) {

    const params = {
      ...data,
      lotId: this.lotId
    };

    this.ocrService.autoVerifyPan(params).subscribe(response => {

      this.autoVerifyData = response;

      this.employeeId = response.employee_id;

      if (response.result.name) {
        return this.showAutoVerifyDetails = true;
      }

      this.OnUnableToValidateDl();
    });
  }

  OnUnableToValidateDl() {

    this.commonService.notifications.error(`Unable to validate ${this.docType}`);
    if (this.docType === 'dl') {
      this.showDocType = true;
      this.documentUploader.resetForm();
      this.documentUploader.ngOnInit();
      this.unableToValidate = true;
      this.ngOnInit();
      this.dataEntryForm.get('de_type').setValue('bike');
      this.dataEntryForm.get('doc_type').setValue('pan');
    } else {
      this.router.navigateByUrl('/home');
    }

  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr.component.ts